import React from 'react'
import { Link } from 'gatsby'
import classNames from 'classnames'

import './MobileNav.css'
import links from '@data/links.json'
import Button from '@components/Common/Button/Button'

const MobileNav = ({ isOpen }) => (
  <section
    className={classNames('c-mobile-nav', {
      'c-mobile-nav--open': isOpen
    })}
  >
    <div className='c-mobile-nav__container'>
      <Link
        to={links.services}
        className='py-3 font-semibold text-xl text-brand-dark'
        activeClassName='text-brand-primary pointer-events-none'
      >
        Services
      </Link>
      <Link
        to={links.useCases}
        className='py-3 font-semibold text-xl text-brand-dark'
        activeClassName='text-brand-primary pointer-events-none'
      >
        Use Cases
      </Link>
      <Link
        to={links.contact}
        className='py-3 font-semibold text-xl text-brand-dark'
        activeClassName='text-brand-primary pointer-events-none'
      >
        Get in Touch
      </Link>
      <Link
        to={links.about}
        className='py-3 font-semibold text-xl text-brand-dark'
        activeClassName='text-brand-primary pointer-events-none'
      >
        About
      </Link>
      <Button className='my-3 self-center' label='Login' link={links.login} />
    </div>
  </section>
)

export default MobileNav
